import React, { useState, useEffect } from "react";
import axios from "../../utils/axios";
import Select from "react-select";
import { HiOutlineUser ,HiClipboardList} from "react-icons/hi";
import { toast } from "react-toastify";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser,setUserHID } from "../../utils/Common";
import { useNavigate } from 'react-router-dom';
import DataTable from "react-data-table-component"; // Import the DataTable
import moment from "moment";

const Transaction = ({ setIsAuthenticated }) => {

  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [propData, setPropData] = useState([]);
  const [userData, setUserData] = useState([]);
  
  const [guestList, setGuestList] = useState([]);

  // Fetch hotel details
  const getDetailProperty = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hotel_id}`);
      if (response.status === 200) {
        setPropData(response.data);
      } else {
        throw new Error("Failed to fetch hotel details");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch hotel details");
    } finally {
      setLoading(false);
    }
  };

  const chooseProperty = async (hotel,url) => {
    navigate(`/property/${hotel}/${url}`)
    setUserHID(hotel)
  }

  const handleRowClick = (phoneNo) => {
    console.log(phoneNo);
    navigate(`/detail/transaction/${phoneNo}`);
  };
  
  const columns = [
        {
            name: "Booking ID",
            wrap:"false",
            selector:  row => {
                return (
                    <div
                    className="flex items-center cursor-pointer"
                    onClick={() => handleRowClick(row.phone)} // Navigate on row click
                    >
                    <HiClipboardList className="mr-1 text-gray-600" />
                    <span>{row.booking_id} </span>
                    </div>
                );},
            sortable: true,
            style: {
                width: '600px',  // Adjust the width here
                whiteSpace: 'nowrap'  // Optional: prevents text wrapping in case 'wrap' is set to false
            }
        },
        
        {
            name: "Guest Name",
            selector: row => {
            return (
                <div
                className="flex items-center cursor-pointer"
                onClick={() => handleRowClick(row.phone)} // Navigate on row click
                >
                <HiOutlineUser className="mr-2 text-gray-600" />
                <span>{`${row.salutation} ${row.firstname} ${row.lastname}`}</span>
                </div>
            );
            },
            sortable: true,
            style: {
            width: '420px',
            whiteSpace: 'nowrap'
            }
        },

        {
            name: "Phone",
            selector: row => row.phone,
            sortable: true,
            style: {
                width: '16px',  // Adjust the width here
                whiteSpace: 'nowrap'  // Optional: prevents text wrapping in case 'wrap' is set to false
            }
        },
        {
            name: "Email",
            selector: row => row.email,
            sortable: true
        },
        {
            name: "Arrival Date",
            selector: row => moment(row.arrival_date).format('ll'),
            sortable: true
        },
        {
            name: "Departure Date",
            selector: row => moment(row.departure_date).format('ll'),
            sortable: true
        },
        {
            name: "Price",
            selector: row => {
            // Convert the price to an integer and format it
            const price = Math.round(row.price); // Ensure it's a whole number
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0, // No decimal places
                maximumFractionDigits: 0  // No decimal places
            }).format(price);
            },
            sortable: true
        }
        
  ];

  // Custom styles for the table
  const customStyles = {
    table: {
      style: {
        border: "1px solid #ddd", // Add border around the table
       
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #ddd", // Add border between rows
        padding: "12px",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#f4f4f4", // Light gray background for headers
        fontWeight: "semibold",
        borderBottom: "1px solid #ddd",
      },
    },
    cells: {
      style: {
        wordWrap: "break-word", // Break text into the next line
        whiteSpace: "normal", // Ensure wrapping
        fontSize:"11px"
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #ddd", // Add border on top of pagination
        paddingTop: "10px",
      },
    },
  };

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    getDetailProperty(userHID)
    const fetchData = async () => {
      const userSession = getUser(); // Call getUser to fetch user data from localStorage
      if (userSession) {
        setUserData(userSession); // Store user data in the state if it exists
        setLoading(true); // Set loading state to true before making the API request
        
        try {

          var uid = userSession.id;
          var hotel = userSession.hotel_id;
         

          // Make sure the hotel_id exists before making the API request
          if (!hotel) {
            throw new Error('Hotel ID is missing');
          }

          // Sending the API request and awaiting the response
          const response = await axios.post('/api/guest/hotel', { uid,hotel }, { headers: { 'Content-Type': 'application/json' } });
          console.log(response.data)
          if (response.status === 200) {
            setGuestList(response.data.data)
           
          } else {
            throw new Error('Failed to fetch property list');
          }
        } catch (err) {
          console.error('Error fetching data:', err);
          alert('An error occurred while fetching data.');
        } finally {
          setLoading(false); // Reset loading state after the API call is completed
        }
      } else {
        navigate('/'); // Navigate to the login page if user data is not found
      }
    };

    fetchData(); // Call the async fetchData function
  }, []); // Empty dependency array to only run once on mount
 
  return (
    <div className="flex h-screen bg-gray-200">
      {/* Sidebar */}
      <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={localStorage.getItem('hid') || "Loading..."}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        
        {/* Topbar */}
        <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar}/>

        {/* Main Section */}
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          {/* Breadcrumb */}
          <div className="mb-4 text-xs font-semibold text-[#101827]">
            <span>Ashley Hotel Group</span> &gt; <span>Transaction</span> &gt; <span> List</span>
          </div>

          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
            {guestList.map((hotel, index) => (
                <div key={index} className="hotel-table mb-4 mt-2">
                  <div className="flex justify-between items-center w-full">
                      <h5 className="hotel-title text-base font-semibold">{hotel.HOTEL}</h5>
                      <img src={hotel.LOGO} alt={hotel.HOTEL} className="rounded-full border-2 p-2 shadow-lg border-gray-200 w-16 h-16 object-scale-down"/>
                  </div>
                  <p className="hotel-address text-xs mb-2">{hotel.ADDRESS}</p>
                  <DataTable
                    columns={columns}
                      data={hotel.booking}
                      pagination
                      highlightOnHover
                      responsive
                    customStyles={customStyles} 
                  />
                </div>
            ))}
            
          </section>

        </main>
      </div>
    </div>
  );
};

export default Transaction;
